// classe libelles avec les champs libelleFr, libelleTraduit, contexte
import { AbstractEntity } from "./AbstractEntity/AbstractEntity";

export class Label extends AbstractEntity {
  id?: number;
  sourceValue?: string;
  targetValue?: string;
  status?: LabelStatus;
  context?: string;
  type?: LabelType;
  pending?: boolean;
}

export enum LabelType {
  I15D = "I15D",
  AIDE_CHAMP = "AIDE_CHAMP",
  PROPERTIES = "PROPERTIES",
}

export enum LabelStatus {
  PENDING = "Pending",
  COMPLETED = "Completed",
  TRANSLATED = "Translated",
  NEEDS_REVIEW = "Needs Review",
}
